import React from 'react'
import {
  SectionPaper,
  SubSectionTitle,
  SectionTitle,
  SubSectionWrapper,
} from 'components/startup/startup-styles'
import { Column } from 'components/common/layout'
import { StartupDetail } from 'types/common'
import { checkEditorDefaultValue, isEndWithConsonant } from 'utils/validations'
import { Video } from 'components/common/video'
import { TextViewer } from 'components/common/text-editor'
import { analytics } from 'infra/analytics'

export const StartupStory: React.FC<{ data: StartupDetail }> = ({ data }) => {
  return (
    <Column id='startupStory'>
      <SectionTitle>창업 스토리</SectionTitle>
      <Column style={{ gap: 32 }}>
        {data.howToStartup && !checkEditorDefaultValue(data.howToStartup) && (
          <SubSectionWrapper>
            <SubSectionTitle>
              Q. {data.name}
              {isEndWithConsonant(data.name) ? '은' : '는'} 어떻게 창업되었나요?
            </SubSectionTitle>
            <SectionPaper>
              <TextViewer value={data.howToStartup} />
            </SectionPaper>
          </SubSectionWrapper>
        )}
        {data.whatKindCompany &&
          !checkEditorDefaultValue(data.whatKindCompany) && (
            <SubSectionWrapper>
              <SubSectionTitle>
                Q. {data.name}
                {isEndWithConsonant(data.name) ? '은' : '는'} 어떤 회사인가요?
              </SubSectionTitle>
              <SectionPaper>
                <TextViewer value={data.whatKindCompany} />
              </SectionPaper>
            </SubSectionWrapper>
          )}
        {data.pitch && (
          <div style={{ borderRadius: 12, overflow: 'hidden' }}>
            <Video
              url={data.pitch}
              onVideoClick={() =>
                analytics.track('click_st_pitch', {
                  startupId: data.id,
                  startupName: data.name,
                })
              }
            />
          </div>
        )}
        {data.curOutcome && !checkEditorDefaultValue(data.curOutcome) && (
          <SubSectionWrapper>
            <SubSectionTitle>Q. 현재까지 성과가 궁금해요</SubSectionTitle>
            <SectionPaper>
              <TextViewer value={data.curOutcome} />
            </SectionPaper>
          </SubSectionWrapper>
        )}
        {data.vision && !checkEditorDefaultValue(data.vision) && (
          <SubSectionWrapper>
            <SubSectionTitle>
              Q. {data.name}
              {isEndWithConsonant(data.name) ? '이' : '가'} 그리는 미래, 비전이
              궁금해요
            </SubSectionTitle>
            <SectionPaper>
              <TextViewer value={data.vision} />
            </SectionPaper>
          </SubSectionWrapper>
        )}
        {data.lookForDev && !checkEditorDefaultValue(data.lookForDev) && (
          <SubSectionWrapper>
            <SubSectionTitle>Q. 어떤 분을 찾고 계신가요?</SubSectionTitle>
            <SectionPaper>
              <TextViewer value={data.lookForDev} />
            </SectionPaper>
          </SubSectionWrapper>
        )}
      </Column>
    </Column>
  )
}
